import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  bgColor: {
    id: 'Colore di sfondo',
    defaultMessage: 'Colore di sfondo',
  },
  addSectionButton: {
    id: 'Aggiungi una sezione',
    defaultMessage: 'Aggiungi una sezione',
  },
  addSectionTitle: {
    id: 'Titolo',
    defaultMessage: 'Titolo',
  },
  accordionSection: {
    id: 'Sezione',
    defaultMessage: 'Sezione',
  },
});

const AccordionSchema = (props) => {
  const intl = useIntl();

  return {
    title: 'Accordion',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['sections', 'styles'],
      },
    ],
    properties: {
      styles: {
        widget: 'object',
        schema: {
          title: 'Stile',
          fieldsets: [
            {
              id: 'default',
              fields: ['bg'],
              title: 'Default',
            },
          ],
          properties: {
            bg: {
              widget: 'color_picker',
              title: intl.formatMessage(messages.bgColor),
              default: 'transparent',
              colors: [
                { name: 'transparent', label: 'Nessuno' },
                { name: 'light-gray', label: 'Grigio chiaro' },
              ],
            },
          },
          required: [],
        },
      },
      sections: {
        widget: 'object_list',
        schema: {
          title: intl.formatMessage(messages.accordionSection),
          addMessage: intl.formatMessage(messages.addSectionButton),
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: ['title'],
            },
          ],
          properties: {
            title: {
              title: intl.formatMessage(messages.addSectionTitle),
            },
          },
          required: [],
        },
      },
    },
    required: [],
  };
};

export default AccordionSchema;
